import React, { useEffect } from "react";

export default function InstagramWidget() {
  useEffect(() => {
    const scriptId = "elfsight-platform-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.src = "https://static.elfsight.com/platform/platform.js";
      script.defer = true;
      script.setAttribute("data-use-service-core", "");
      script.id = scriptId;
      document.body.appendChild(script);
    }

    const interval = setInterval(() => {
      const el = document.querySelector(".eapps-instagram-feed > a");
      if (el) {
        el.style.display = "none";
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="elfsight-app-3410539e-e57f-48f9-8617-6b3abe6012b4" data-elfsight-app-lazy></div>
  );
}